<template>
    <section
        v-editable="blok"
        class="image-link-grid"
    >
        <KSectionHeader
            class="image-link-grid__header"
            :eyebrow="blok.eyebrow"
            :text="blok.text"
            :align="blok.align || 'start'"
        >
            <template
                v-if="title"
                #title
            >
                <span v-html="title" />
            </template>
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="image-link-grid"
                />
            </template>
        </KSectionHeader>

        <div class="image-link-grid__items">
            <image-link-grid-item
                v-for="link in blok.links"
                :key="link._uid"
                :item="link"
                :story="stories?.[link.article]"
                :aspect-ratio="blok.aspect_ratio"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'
import renderHighlightedText from '~/helpers/renderHighlightedText'

const { blok } = defineProps(['blok'])

const title = computed(() => renderHighlightedText(blok.title))

// One batched request for the whole grid instead of one per tile — the
// per-tile fan-out burst was enough to trip Storyblok's rate limit on a cold
// cache, silently blanking tiles (see server/api/pages-by-uuids.js). The
// watch re-fetches when the editor adds/removes/repoints tiles.
const uuids = computed(() => (blok.links || []).map(link => link.article).filter(Boolean))

const { data: stories } = await useAsyncData(
    `image-link-grid-${blok._uid}`,
    () => (uuids.value.length ? $fetch(`/api/pages-by-uuids?uuids=${uuids.value.join(',')}`) : {}),
    { watch: [uuids] },
)
</script>

<style lang="scss">
@use 'image-link-grid';
</style>
